module.exports = {"220422100":"白泉镇","220422101":"渭津镇","220422102":"安石镇","220422103":"辽河源镇","220422104":"泉太镇","220422105":"建安镇","220422106":"安恕镇","220422107":"平岗镇","220422108":"云顶镇","220422200":"凌云乡","220422201":"甲山乡","220422202":"足民乡","220422203":"金洲乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220422.json
// module id = 638
// module chunks = 0